<span class="datasource-access-level">
  {{ description }}
  <capra-icon
    class="capra-icon"
    icon="{{ iconType }}"
  ></capra-icon>
</span>
